export default [
    {
        path: '/website-product-tags/type',
        props: true,
        component: () => import('@/views/WebsiteProduct/Tag/Type'),
    },
];
